import { Button, Input } from '@nextui-org/react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/modal';

import React from 'react';
import { PartnerInfo } from '../../types';

interface EditPartnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  formData: Partial<PartnerInfo>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
}

const EditPartnerModal: React.FC<EditPartnerModalProps> = ({
  isOpen,
  onClose,
  onSave,
  formData,
  handleChange,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1 pb-2">
          <h3 className="text-lg font-bold text-slate-800">Edit Partner</h3>
          <p className="text-xs text-slate-400 font-normal">
            Update partner account details
          </p>
        </ModalHeader>
        <ModalBody className="gap-4">
          <Input
            name="company_name"
            label="Company Name"
            variant="bordered"
            radius="sm"
            value={formData.company_name || ''}
            onChange={handleChange}
            classNames={{ label: 'text-slate-500 text-xs' }}
          />
          <div className="grid grid-cols-2 gap-3">
            <Input
              name="first_name"
              label="First Name"
              variant="bordered"
              radius="sm"
              value={formData.first_name || ''}
              onChange={handleChange}
              classNames={{ label: 'text-slate-500 text-xs' }}
            />
            <Input
              name="last_name"
              label="Last Name"
              variant="bordered"
              radius="sm"
              value={formData.last_name || ''}
              onChange={handleChange}
              classNames={{ label: 'text-slate-500 text-xs' }}
            />
          </div>
          <Input
            name="email"
            label="Email Address"
            variant="bordered"
            radius="sm"
            value={formData.email || ''}
            onChange={handleChange}
            classNames={{ label: 'text-slate-500 text-xs' }}
          />
        </ModalBody>
        <ModalFooter className="pt-2">
          <Button
            variant="bordered"
            onClick={onClose}
            radius="sm"
            className="border-slate-300 text-slate-600"
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={onSave}
            radius="sm"
            className="bg-airlock-purple font-medium"
            isLoading={isLoading}
          >
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditPartnerModal;
